import { createPage } from "~/js/utils";

// Pages.makePage("welcome", document.getElementById("welcome-page-static")!);

export function WelcomePage() {
	return (
		<div
			class="page"
			id="welcome-page-static"
			// @ts-expect-error
			page="welcome"
			style="background: radial-gradient(circle at center bottom, rgb(12, 37, 36), rgb(47, 36, 49)); box-shadow: rgb(34, 34, 34) 0px 0px 32px 4px inset;"
		>
			<div class="welcome-page-title">Case Clicker 2</div>
			<div class="welcome-page-information-row">
				<div>
					<div class="welcome-page-information-box">
						<h2 class="welcome-page-information-box-title">Welcome!</h2>
						<div class="welcome-page-information-box-content">
							<p>Welcome to Case Clicker </p>
							<p>
								This is a game based on CS2, skins orignally made by Malthe, and being revamped by <a href="https://x.com/ozeniken">me</a>
							</p>

							<p>
								If you know my old game, this should be very similar, and you can properly go play straight away via the navigation on the
								left.
							</p>
							<p>If you don't know what Case Clicker is: it's a game about collecting skins from cases and gambling them away.</p>
							<p>Start your game by going to your inventory and try opening the case there.</p>
							<p>
								To get more cases, go to the Earn tab and click to earn money. With the money you can buy new cases from the shop, which
								will appear in your inventory.
							</p>
							<p>To gamble your skins, see what's inside the Games tab.</p>
						</div>
					</div>
				</div>
				<div>
					<div class="welcome-page-information-box">
						<h2 class="welcome-page-information-box-title">
							Changes in version 2.19.1! <span style="font-size: 0.6em; font-style: italic;">v2.19.1</span>
						</h2>
						<div class="welcome-page-information-box-content">
							<ul>
								<li>Added Prestige, reach level 40 to prestige.</li>
								<li>Added 7 upgrades.</li>
								<li>Added Daily Missions.</li>
								<li>Added Sounds.</li>
								<li>You can now sort your inventory by the quality of your skins.</li>
								<li>Improvements to Crash: Automatically bet and cash out at a specific multiplier.</li>
								<li>
									Cases first sorting now sorts correctly in decreasing price with cases and capsules first, then keys, and then all other
									items.
								</li>
								<li>Instant Opening cases, winning coinflips and winning online jackpot now shows total value of winnings.</li>
								<li>
									You can now spin the roulette and daily wheel fast by holding down <kbd>SHIFT</kbd>when betting.
								</li>
								<li>You can now filter for missing items in your collection.</li>
								<li>Purchasing upgrades now gives xp.</li>
								<li>Lucky wheel is now faster and has more rewards</li>
								<li>You can now see exactly how many chips you have by hovering over the chips counter on the left.</li>
								<li>The collection now shows the correct number of discovered stickers.</li>
								<li>"Discover new skins" mission now won't appear once you have discovered all skins.</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

createPage(() => <WelcomePage />, "welcome");
